import { render, staticRenderFns } from "./KabAsmat.vue?vue&type=template&id=18f70bc2"
import script from "./KabAsmat.vue?vue&type=script&lang=js"
export * from "./KabAsmat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports